import { Box, Button, makeStyles, Typography } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';

type Props = {
  href?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  label?: string;
  icon?: JSX.Element;
  active?: boolean;
  className?: string;
};

const useStyle = makeStyles(theme => ({
  box: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // color: theme.palette.primary.main,
  },
  button: {
    textTransform: 'none',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: 0,
    opacity: 0.7,
    '&:hover': {
      opacity: 1,
    },
  },
  buttonActive: {
    boxShadow: `0px -2px 0px ${theme.palette.primary.main} inset`,
    color: theme.palette.primary.main,
    opacity: 1,
    "& >span >div >svg": {
      color: theme.palette.primary.main + " !important",
    },
  },
}));

const MenuItem: React.FC<Props> = ({
  href,
  onClick,
  label,
  icon,
  active,
  className,
}) => {
  const style = useStyle();
  const { pathname } = useLocation();
  const history = useHistory();
  const isActive = (href && pathname.indexOf(href) > -1) || active;
  const goTo = useCallback(() => href && history.push(href), [history, href]);
  return (
    <Button
      onClick={href ? goTo : onClick}
      className={[
        style.button,
        isActive ? style.buttonActive : '',
        className,
      ].join(' ')}
    >
      <Box className={style.box}>
        {icon}
        <Typography variant="caption">{label}</Typography>
      </Box>
    </Button>
  );
};

MenuItem.displayName = 'MenuItem';

export default React.memo(MenuItem);
